class MileageReportController {
  /*@ngInject*/
    constructor() {}
  $onInit() {}
}
export default MileageReportController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/mileage_report/mileage_report.controller.js